// The languages code blocks are highlighted in, and the other names people write for them. Kept
// apart from the highlighter so the editor can offer them without loading it.

export const LANGUAGES = [
  "bash",
  "c",
  "cpp",
  "csharp",
  "css",
  "diff",
  "dockerfile",
  "go",
  "java",
  "javascript",
  "json",
  "kotlin",
  "markdown",
  "php",
  "python",
  "ruby",
  "rust",
  "sql",
  "swift",
  "typescript",
  "xml",
  "yaml",
] as const;

export type Language = (typeof LANGUAGES)[number];

/** How each language is named in the editor's language picker. */
export const LANGUAGE_NAMES: Record<Language, string> = {
  bash: "Bash",
  c: "C",
  cpp: "C++",
  csharp: "C#",
  css: "CSS",
  diff: "Diff",
  dockerfile: "Dockerfile",
  go: "Go",
  java: "Java",
  javascript: "JavaScript",
  json: "JSON",
  kotlin: "Kotlin",
  markdown: "Markdown",
  php: "PHP",
  python: "Python",
  ruby: "Ruby",
  rust: "Rust",
  sql: "SQL",
  swift: "Swift",
  typescript: "TypeScript",
  xml: "HTML or XML",
  yaml: "YAML",
};

const ALIASES: Record<string, Language> = {
  sh: "bash",
  shell: "bash",
  zsh: "bash",
  console: "bash",
  h: "c",
  "c++": "cpp",
  cc: "cpp",
  hpp: "cpp",
  cs: "csharp",
  "c#": "csharp",
  patch: "diff",
  docker: "dockerfile",
  golang: "go",
  js: "javascript",
  jsx: "javascript",
  mjs: "javascript",
  cjs: "javascript",
  node: "javascript",
  jsonc: "json",
  kt: "kotlin",
  kts: "kotlin",
  md: "markdown",
  py: "python",
  python3: "python",
  rb: "ruby",
  rs: "rust",
  postgres: "sql",
  postgresql: "sql",
  psql: "sql",
  mysql: "sql",
  sqlite: "sql",
  ts: "typescript",
  tsx: "typescript",
  mts: "typescript",
  html: "xml",
  svg: "xml",
  xhtml: "xml",
  plist: "xml",
  yml: "yaml",
};

/** The language a fence names, or null when it is not one of the common ones. */
export function grammarFor(lang: string | null | undefined): Language | null {
  if (!lang) return null;
  const name = lang.toLowerCase();
  if ((LANGUAGES as readonly string[]).includes(name)) return name as Language;
  return ALIASES[name] ?? null;
}
